<template>
  <v-autocomplete
    v-model="select"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    @change="setLocalId"
    :label="$t('localManager')"
    item-text="name"
    item-value="id"
    prepend-icon="mdi-account-multiple green--text"
    dense
    filled
    hide-details
    solo-inverted
    clearable
    @click:clear="clearable()"
  >
    <!-- UI com o ICON WEB caso o Local seja Online (afiliado) -->
    <template v-slot:item="data">
      {{ data.item.name }}
      <v-icon small color="primary" class="mx-2" v-if="data.item.comissao">
        mdi-web
      </v-icon>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-regionals",
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
    endpoint: "",
    level: "",
  }),
  async created() {
    // ====================================================
    // 1. Config Endpoint:
    this.level = localStorage.getItem("level");

    let level = "";

    if (this.level === "collaborator") {
      level = "colab";
    } else {
      level = this.level;
    }

    this.endpoint = `${level}/locals/list`;

    // ====================================================
    // 2. Request If Level Regional Manager
    if (this.level == "regionalManager") {
      this.getLocalsList();
    }
  },
  computed: {
    enableAutocompleteRegionals() {
      return this.$store.state.filters.autocompleteRegionals.enable;
    },
    enableAutocompleteLocals() {
      return this.$store.state.filters.autocompleteLocals.enable;
    },
    // ====================================================
    // 2. IF - Administrator (Setup Id Regional)
    id_regional() {
      if (this.level == "administrator" || this.level == "collaborator") {
        return this.$store.state.filters.autocompleteRegionals.id;
      }
      return null;
    },
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.items.length > 0) return;
      // Items have already been requested
      if (this.isLoading) return;
      // Request
      this.getLocalsList();
    },
    // ====================================================
    // 3. IF - Administrator
    id_regional(val) {
      if (this.enableAutocompleteLocals) {
        val && this.getLocalsList();
      }
    },
    // Observar a "troca de rota" ou o array de "items",
    // e se caso existir o id_local na url (query ou params),
    // filtrar o item, exibir no select e setLocalId no store:
    items() {
      this.selectLocalByQueryOrParams();
    },
    $route() {
      this.selectLocalByQueryOrParams();

      // Tratamento para view específica "AdministratorAgentBetList"
      // promove mais consistência no autocomplete
      if (
        this.level == "administrator" &&
        this.$route.query.id_regional &&
        this.$route.query.id_local &&
        this.$route.name == "AdministratorAgentBetList"
      ) {
        this.getLocalsList();
      }
    },
  },
  methods: {
    clearable() {
      this.$store.commit("setLocalId", "");
    },

    setLocalId(localsId) {
      this.$store.commit("setLocalId", localsId ? localsId : "");
    },

    async getLocalsList() {
      this.isLoading = true;
      try {
        const response = await this.$request.post(this.endpoint, {
          status: 1,
          // if - administrator level follow:
          id_regional: this.id_regional,
        });

        if (response.length == 0) {
          this.items = [];
          return;
        }

        this.items = response.dados.map((item) => ({
          name: `${item.name_local} (${item.id})`,
          id: item.id,
          comissao: item.comissao_online ? item.comissao_online : "",
        }));
        this.$store.commit("listUsersLocals", this.items);
        if (this.$route.params.id_local || this.$route.query.id_local) {
          this.selectLocalByQueryOrParams();
        }
      } finally {
        this.isLoading = false;
      }
    },

    selectLocalByQueryOrParams() {
      let select;

      if (this.$route.params.id_local) {
        select = this.items.filter(
          (item) => item.id == this.$route.params.id_local
        );
      }

      if (this.$route.query.id_local) {
        select = this.items.filter(
          (item) => item.id == this.$route.query.id_local
        );
      }

      if (!this.$route.params.id_local && !this.$route.query.id_local) {
        return;
      }

      if (select[0] == undefined) return;
      this.select = select[0];
      this.setLocalId(this.select.id);
    },
  },
};
</script>
